import api from '../../lib/api';
import type {
  ChangeRequestPayload,
  ChangeRequestSummary,
  PaginatedChangeRequests,
  TransitionChangeRequestPayload,
} from './types';
import type { IsoStandard } from '../../constants/isoStandards';

export interface ListChangeRequestsParams {
  changeType?: string;
  status?: string;
  standard?: IsoStandard;
  search?: string;
  page?: number;
  pageSize?: number;
  sortBy?: string;
  sortDir?: 'asc' | 'desc';
}

export const fetchChangeRequests = async (
  params: ListChangeRequestsParams = {},
): Promise<PaginatedChangeRequests> => {
  const { data } = await api.get<PaginatedChangeRequests>('change-requests', { params });
  return data;
};

export const fetchChangeRequest = async (id: string): Promise<ChangeRequestSummary> => {
  const { data } = await api.get<ChangeRequestSummary>(`change-requests/${id}`);
  return data;
};

export const createChangeRequest = async (payload: ChangeRequestPayload) => {
  const { data } = await api.post('change-requests', payload);
  return data;
};

export const updateChangeRequest = async (
  id: string,
  payload: Partial<ChangeRequestPayload>,
) => {
  const { data } = await api.put(`change-requests/${id}`, payload);
  return data;
};

export const transitionChangeRequestStatus = async (
  id: string,
  payload: TransitionChangeRequestPayload,
) => {
  const { data } = await api.patch(`change-requests/${id}/status`, payload);
  return data;
};

export const escalateChangeRequest = async (
  id: string,
  payload?: { title?: string; description?: string },
) => {
  const { data } = await api.post(`change-requests/${id}/escalate`, payload ?? {});
  return data;
};
